import {FC} from 'react';
import Button from '@/shared/components/Button';
import {Box, Icon, Typography} from '@mui/material';
import {ReactComponent as CheckedIcon} from '@icons/rudiobutton-checked-blue.svg';
import {twoStepAuthenticationStyles} from './TwoStepAuthentication.styles';

interface TwoStepAuthenticationModalStep3Props {
  onClose: () => void;
}

const SuccessStep: FC<TwoStepAuthenticationModalStep3Props> = ({onClose}) => {
  return (
    <Box>
      <Icon sx={twoStepAuthenticationStyles.iconChecked}>
        <CheckedIcon />
      </Icon>
      <Typography sx={twoStepAuthenticationStyles.mainTitle}>Two-Step Verification Enabled</Typography>
      <Typography sx={twoStepAuthenticationStyles.mainDescription}>
        Now we will ask you to enter a passcode every time you sign in to your account from an unrecognized device.
      </Typography>
      <Box sx={twoStepAuthenticationStyles.buttonWrapper}>
        <Button title="Done" onClick={onClose} />
      </Box>
    </Box>
  );
};

export default SuccessStep;
